"use strict";

// Connecting vendors (plugins)
import "./_vendor";

// Functions
import { mobileCheck, accordion, burger } from "./functions/";

// Components
// import { formValidation } from "./components/";

window.addEventListener("DOMContentLoaded", () => {
  mobileCheck();
  burger();
  accordion(
    ".faq__list",
    "faq__title",
    ".faq__wrap",
    "faq__item--active",
    false
  );
});
